import { render, staticRenderFns } from "./RegioesView.vue?vue&type=template&id=7dcbd53a&"
import script from "./RegioesView.vue?vue&type=script&lang=ts&"
export * from "./RegioesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports